import { useAuthStore } from '@/store/authStore';

export type TokenProvider = (options?: { skipCache?: boolean }) => Promise<string | null>;

let _getToken: TokenProvider | null = null;

/** Inject a Clerk-style getToken function. Called by TokenSync in main.tsx. */
export function setTokenProvider(provider: TokenProvider): void {
  _getToken = provider;
}

/** Drop the injected provider. Test-only. */
export function clearTokenProvider(): void {
  _getToken = null;
}

/**
 * Resolve a Bearer token for an API request.
 *
 * Priority:
 *   1. Kiosk pairing token from authStore (production kiosk mode).
 *   2. Clerk JWT from the injected provider (developer mode).
 *
 * Returns null when neither source has a token — callers should send the
 * request anyway and let the server return 401, which lets `apiFetch`
 * make the right decision (clear auth vs retry).
 */
export async function getAuthToken(): Promise<string | null> {
  const kioskToken = useAuthStore.getState().kioskToken;
  if (kioskToken) return kioskToken;
  if (_getToken) return _getToken();
  return null;
}
